const loginTypeConstant = {
  Employee: "Employee",
  Worker: "Worker"
};

const statusOfUser = {
  Active: true,
  DeActive: false
};

export { loginTypeConstant, statusOfUser };
